// import * as algoliasearch from 'algoliasearch';

import * as secrets from '@/secrets';
import { ListModel } from '@/models/list-model';
import { ItemModelUtil } from '@/model-utils/item-model-util';
const algoliasearch = require('algoliasearch');

export class SearchActions {
  public static client = algoliasearch(
    secrets.ALGOLIA_ID,
    secrets.ALGOLIA_SEARCH_KEY
  );

  public static doSearch(query: string): Promise<any[]> {
    const index = SearchActions.client.initIndex('dev_mixlet');

    return index.search({ query }).then((results: any) => {
      return results.hits.map((result: any) => {
        if (result.objectType == 'list') {
          return {list: ListModel.fromFirebaseDoc(result.objectID, result)};
        } else if (result.objectType === 'item') {
          return {item: ItemModelUtil.itemDocToDomainModel(result.objectID, result)};
        } else {
          throw new Error('unknown objectType ' + result.objectType);
        }
      });
    });
  }
}
